import { StatsChartConfiguration } from '@pages/statistics-page/interfaces';

export class ChartUtils {
  static hexToRGBA(hex = '#fff', alpha = 1): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  static getGenericChartConfig(titleText: string): StatsChartConfiguration {
    return {
      title: {
        left: 'center',
        text: titleText,
        textStyle: {
          fontFamily: 'sans-serif',
          fontSize: '16',
          overflow: 'none',
          color: '#000000',
        },
      },
      responsive: true,
      tooltip: {
        trigger: 'item',
        confine: true,
      },
    };
  }
}
